import { Chain } from './chains';
import { http } from './http';

export type Donor = {
  id: string;
  type: 'donor';
  name: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  zipCode: string;
  chain?: Chain;
};

export const fetchDonors = async () => {
  const { data } = await http.get<Donor[]>('/donors');

  return data;
};

export const fetchDonorsByReceiverId = async (receiverId: string) => {
  const { data } = await http.get<Donor[]>(`/donation/receivers/${receiverId}/partnership`);

  return data;
};
